import { useState } from 'react'
import { PageHeader } from '../components/UI'
import { useAuth } from '../context/AuthContext'
import { put } from '../utils/api'
import { IconCheck } from '@tabler/icons-react'

export default function ProfilePage() {
  const { user, refreshUser } = useAuth()
  const [form, setForm] = useState({ name: user?.name || '', email: user?.email || '', phone: user?.phone || '', title: user?.title || '' })
  const [pwForm, setPwForm] = useState({ current: '', newPw: '', confirm: '' })
  const [saving, setSaving] = useState(false)
  const [msg, setMsg] = useState('')
  const [pwMsg, setPwMsg] = useState('')

  const handleSave = async () => {
    setSaving(true); setMsg('')
    try { await put('/team/me', form); setMsg('Profile updated'); if (refreshUser) refreshUser() }
    catch (err) { setMsg(err.message) } finally { setSaving(false) }
  }

  const handlePassword = async () => {
    if (pwForm.newPw !== pwForm.confirm) { setPwMsg('Passwords do not match'); return }
    setPwMsg('')
    try { await put('/team/me/password', { current_password: pwForm.current, new_password: pwForm.newPw }); setPwMsg('Password updated'); setPwForm({ current: '', newPw: '', confirm: '' }) }
    catch (err) { setPwMsg(err.message) }
  }

  const initials = user?.name?.split(' ').map(n => n[0]).join('').toUpperCase() || '?'

  return (
    <>
      <PageHeader title="My Profile" />
      <div className="row row-cards">
        <div className="col-lg-4">
          <div className="card">
            <div className="card-body text-center">
              <span className="avatar avatar-xl rounded-circle bg-primary-lt mb-3" style={{ fontSize: '1.5rem' }}>{initials}</span>
              <h3 className="mb-0">{user?.name}</h3>
              <div className="text-secondary" style={{ textTransform: 'capitalize' }}>{(user?.role || '').replace(/_/g, ' ')}</div>
              <div className="text-secondary mt-1" style={{ fontSize: '0.85rem' }}>{user?.hotel_name}</div>
            </div>
            <div className="card-body border-top">
              <div className="datagrid">
                <div className="datagrid-item"><div className="datagrid-title">Email</div><div className="datagrid-content">{user?.email}</div></div>
                <div className="datagrid-item"><div className="datagrid-title">Phone</div><div className="datagrid-content">{user?.phone || '—'}</div></div>
                <div className="datagrid-item"><div className="datagrid-title">Title</div><div className="datagrid-content">{user?.title || '—'}</div></div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-8">
          <div className="card mb-3">
            <div className="card-header"><h3 className="card-title">Edit Profile</h3></div>
            <div className="card-body">
              {msg && <div className={`alert ${msg.includes('updated') ? 'alert-success' : 'alert-danger'}`}>{msg}</div>}
              <div className="row g-3">
                {[{ label: 'Name', key: 'name' }, { label: 'Email', key: 'email', type: 'email' },
                  { label: 'Phone', key: 'phone', type: 'tel' }, { label: 'Title', key: 'title' }].map(f => (
                  <div key={f.key} className="col-md-6">
                    <label className="form-label">{f.label}</label>
                    <input type={f.type || 'text'} className="form-control" value={form[f.key]} onChange={e => setForm({ ...form, [f.key]: e.target.value })} />
                  </div>
                ))}
              </div>
            </div>
            <div className="card-footer text-end">
              <button className="btn btn-primary" disabled={saving} onClick={handleSave}>
                {saving ? 'Saving...' : <><IconCheck size={16} className="me-1" />Save Changes</>}
              </button>
            </div>
          </div>

          <div className="card">
            <div className="card-header"><h3 className="card-title">Change Password</h3></div>
            <div className="card-body">
              {pwMsg && <div className={`alert ${pwMsg.includes('updated') ? 'alert-success' : 'alert-danger'}`}>{pwMsg}</div>}
              <div className="row g-3">
                <div className="col-md-4"><label className="form-label">Current Password</label><input type="password" className="form-control" value={pwForm.current} onChange={e => setPwForm({ ...pwForm, current: e.target.value })} /></div>
                <div className="col-md-4"><label className="form-label">New Password</label><input type="password" className="form-control" value={pwForm.newPw} onChange={e => setPwForm({ ...pwForm, newPw: e.target.value })} /></div>
                <div className="col-md-4"><label className="form-label">Confirm</label><input type="password" className="form-control" value={pwForm.confirm} onChange={e => setPwForm({ ...pwForm, confirm: e.target.value })} /></div>
              </div>
            </div>
            <div className="card-footer text-end">
              <button className="btn btn-outline-primary" onClick={handlePassword}>Update Password</button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
